import Container from './edit-billing-info-container';

export default Container;
